import type { User } from '@/types';
import { BrandMarkIcon } from '@/components/icons';

interface GreetingHeaderProps {
  user: User;
}

export function GreetingHeader({ user }: GreetingHeaderProps) {
  const isOperator = user.role === 'operator';
  const hour = new Date().getHours();
  const timeOfDay = hour < 12 ? 'morning' : hour < 17 ? 'afternoon' : 'evening';

  const greetingWord = isOperator ? `Good ${timeOfDay},` : 'Welcome,';
  const displayName = isOperator
    ? `${user.firstName} ${user.lastName}`
    : `${user.lastName}, ${user.firstName}`;

  return (
    <div className="greeting">
      <div className="greeting__icon">
        <BrandMarkIcon size={44} />
      </div>
      <div className="greeting__text">
        <h1 className="greeting__headline">
          <span className="greeting__word">{greetingWord}</span>{' '}
          <span className="greeting__name">{displayName}</span>
        </h1>
        <p className="greeting__subtitle">
          You are in {user.site}. You can work with people, credentials, and devices, and review
          access events for this site.
        </p>
      </div>
    </div>
  );
}
